module.exports = __webpack_public_path__ + "img/product8.470c104d.jpg";